import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
// components
import { TrackingSales } from "../../../../components/modules/report/tracking-sales";
import TrackingSalesMiddleware from "../../../../middleware/modules/report/tracking-sales";
import i18n from "../../../../i18n";
import { Helmet } from "react-helmet";
// middlewares
const mapStateToProps = ({ trackingSales }) => ({
  isProcessing: trackingSales.isProcessing,
  isError: trackingSales.isError,
  errorMessage: trackingSales.errorMessage,
  datalist: trackingSales.data,
  helper:trackingSales.helperTrackingSales,
  tracking:trackingSales.timeline,
  dataTracking:trackingSales.dataTracking,
  loading:trackingSales.loadingDetails,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getHelper:()=>TrackingSalesMiddleware.getHelper(),
      reset: () =>TrackingSalesMiddleware.reset(),
      getTracking:(post)=>TrackingSalesMiddleware.Tracking(post),
      getData:(type,id)=>TrackingSalesMiddleware.getData(type,id)
    },
    dispatch
  );
};
class TrackingSalesContainer extends Component {
  static propTypes = {
    isAuthenticated: PropTypes.bool,
    isProcessing: PropTypes.bool,
    isRegistered: PropTypes.bool,
    isError: PropTypes.bool,
    errorMessage: PropTypes.any,
    datalist: PropTypes.object,
  };

  static defaultProps = {
    isAuthenticated: false,
    isProcessing: false,
    isRegistered: false,
    isError: false,
    errorMessage: [],
  };

  constructor(props) {
    super(props);
  }

  componentWillMount() {
    this.props.reset();
    this.props.getHelper();
  }
  
  render() {
    return (
      <React.Fragment>
        <Helmet>
          <title>
            {i18n.t("Tracking Sales")}
          </title>
        </Helmet>
      <TrackingSales
        {...this.props}
      />
      </React.Fragment>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TrackingSalesContainer);
